import React, { useMemo } from "react";
import { Modal } from "antd";
import CloseIcon from "@mui/icons-material/Close";

import JobSwmsV3AddEditPreStartQuestionForm from "./JobSwmsV3AddEditPreStartQuestionForm";
import { getPreStartQuestionInitialValuesV3 } from "./preStartQuestionFormConfigV3";
import styles from "../../../../../SwmsMasters/SwmsMastersStyle.module.css";

export default function JobSwmsV3AddEditPreStartQuestionModal({
  visible,
  mode,
  selectedQuestion,
  methodOptions,
  onCancel,
  onSubmit
}) {
  const formInitialValues = useMemo(() => getPreStartQuestionInitialValuesV3({
    mode,
    selectedQuestion,
    methodOptions
  }), [mode, selectedQuestion, methodOptions]);

  return (
    <Modal
      className="cs-modal-v2"
      centered
      footer={null}
      visible={visible}
      onCancel={onCancel}
      afterClose={() => null}
      bodyStyle={{ paddingRight: "0px", paddingLeft: "0px" }}
      destroyOnClose
      closeIcon={<div className={styles.ModalCloseIcon}><CloseIcon /></div>}
    >
      {visible ? (
        <JobSwmsV3AddEditPreStartQuestionForm
          mode={mode}
          selectedQuestion={selectedQuestion}
          initialValues={formInitialValues}
          methodOptions={methodOptions}
          onClose={onCancel}
          onSubmitSuccess={onSubmit}
        />
      ) : null}
    </Modal>
  );
}
